export const metaReceiptMixin = {
	data() {
		return {
			currencies: [],
		}
	},
	methods: {
		load_meta_data() {
			this.errormsg = '';
			let self = this;

			let url = "/api/expenses/receipts/meta"
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					if (json.status == "OK") {
						// console.log(json.data.currencies);

						self.currencies = json.data.currencies;
						
					} else {
						console.log('failed to retrieve');
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					self.errormsg = e.message;
				})
		},
	}
}
